/* st-reviews.js — Bewertungen (ST), Frontend-Verhalten
   Spec: docs/superpowers/specs/2026-08-03-st-reviews-design.md

   Setzt auf st-reviews.core.js auf (gemeinsame Pruefregeln mit dem Backend).
   Ohne JavaScript bleiben Anzeige und Statistik vollstaendig nutzbar —
   nur das Absenden entfaellt, weil der Datei-Upload JS voraussetzt. */
(function () {
  'use strict';

  var core = window.STReviewsCore;
  if (!core) return;

  var TOKEN_PARAM = 'st_token';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function getToken() {
    try {
      return new URLSearchParams(window.location.search).get(TOKEN_PARAM) || '';
    } catch (e) {
      return '';
    }
  }

  /* ---------------------------------------------------------------- */
  /* Sterne-Eingabe                                                    */
  /* ---------------------------------------------------------------- */

  function initRating(form) {
    var group = qs(form, '[data-st-rv-rate]');
    if (!group) return;

    var options = qsa(group, '.st-rv-rate__option');
    var inputs = qsa(group, '[data-st-rv-rate-input]');

    function paint(value) {
      var fills = core.starFills(value);
      for (var i = 0; i < options.length; i++) {
        if (fills[i] > 0) { options[i].classList.add('is-on'); }
        else { options[i].classList.remove('is-on'); }
      }
    }

    function selected() {
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].checked) return parseInt(inputs[i].value, 10);
      }
      return 0;
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () { paint(selected()); });
      // Fokus per Tastatur soll denselben Vorschau-Effekt zeigen wie Hover
      input.addEventListener('focus', function () { paint(parseInt(input.value, 10)); });
      input.addEventListener('blur', function () { paint(selected()); });
    });

    options.forEach(function (option, index) {
      option.addEventListener('mouseenter', function () { paint(index + 1); });
    });
    group.addEventListener('mouseleave', function () { paint(selected()); });

    paint(0);
  }

  /* ---------------------------------------------------------------- */
  /* Zeichenzaehler und Namensmaskierung                               */
  /* ---------------------------------------------------------------- */

  function initCounter(form) {
    var field = qs(form, '[data-st-rv-counted]');
    var out = qs(form, '[data-st-rv-counter]');
    if (!field || !out) return;

    function update() { out.textContent = String(field.value.length); }
    field.addEventListener('input', update);
    update();
  }

  function initMask(form) {
    var button = qs(form, '[data-st-rv-mask]');
    var input = qs(form, '[data-st-rv-name]');
    if (!button || !input) return;

    button.addEventListener('click', function () {
      var masked = core.maskAuthorName(input.value);
      if (masked) {
        input.value = masked;
        input.focus();
      }
    });
  }

  /* ---------------------------------------------------------------- */
  /* Datei-Vorschau                                                    */
  /* ---------------------------------------------------------------- */

  function formatBytes(bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(1).replace('.', ',') + ' MB';
    return Math.max(1, Math.round(bytes / 1024)) + ' KB';
  }

  function initFiles(form, showError) {
    var input = qs(form, '[data-st-rv-files]');
    var list = qs(form, '[data-st-rv-preview]');
    var drop = qs(form, '[data-st-rv-drop]');
    var status = qs(form, '[data-st-rv-file-status]');
    var hinweis = qs(form, '[data-st-rv-file-note]');
    if (!input || !list) return;

    // Grenze aus dem gemeinsamen Regelwerk, damit Frontend und Backend
    // nicht auseinanderlaufen.
    var MAX_DATEIEN = (core.limits && core.limits.MAX_FILES) || 3;

    // Eigene Liste fuehren: input.files ist nicht direkt veraenderbar, wir
    // brauchen sie aber, um einzelne Dateien wieder entfernen zu koennen.
    var gewaehlt = [];

    function ansagen(text) {
      if (status) status.textContent = text;
    }

    // Auswahl zurueck ins Feld schreiben, damit das Formular sie mitsendet.
    function uebernehmen() {
      if (typeof DataTransfer === 'undefined') return;
      var dt = new DataTransfer();
      gewaehlt.forEach(function (f) { dt.items.add(f); });
      input.files = dt.files;
    }

    function pruefen() {
      var check = core.validateFiles(gewaehlt.map(function (f) {
        return { name: f.name, type: f.type, size: f.size };
      }));
      showError('media', check.valid ? '' : check.errors.join(' '));
      return check.valid;
    }

    function zeichnen() {
      list.innerHTML = '';

      gewaehlt.forEach(function (file, index) {
        var item = document.createElement('li');
        item.className = 'st-rv-preview__item';

        var vorschau = document.createElement('span');
        vorschau.className = 'st-rv-preview__thumb';
        if (file.type.indexOf('image/') === 0) {
          var img = document.createElement('img');
          img.alt = '';
          img.src = URL.createObjectURL(file);
          img.addEventListener('load', function () { URL.revokeObjectURL(img.src); });
          vorschau.appendChild(img);
        } else {
          vorschau.classList.add('st-rv-preview__thumb--video');
          vorschau.textContent = 'Video';
        }
        item.appendChild(vorschau);

        var meta = document.createElement('span');
        meta.className = 'st-rv-preview__meta';
        var name = document.createElement('span');
        name.className = 'st-rv-preview__name';
        name.textContent = file.name;
        var groesse = document.createElement('span');
        groesse.className = 'st-rv-preview__size';
        groesse.textContent = formatBytes(file.size);
        meta.appendChild(name);
        meta.appendChild(groesse);
        item.appendChild(meta);

        var weg = document.createElement('button');
        weg.type = 'button';
        weg.className = 'st-rv-preview__remove';
        weg.setAttribute('aria-label', file.name + ' entfernen');
        weg.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">'
          + '<path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" fill="none"/></svg>';
        weg.addEventListener('click', function () {
          var entfernt = gewaehlt[index].name;
          gewaehlt.splice(index, 1);
          uebernehmen();
          pruefen();
          zeichnen();
          ansagen(entfernt + ' entfernt. ' + gewaehlt.length + ' von ' + MAX_DATEIEN + ' Dateien ausgewählt.');
          if (hinweis) hinweis.textContent = '';
          // Fokus nicht ins Leere laufen lassen
          var naechste = qs(list, '.st-rv-preview__remove');
          if (naechste) naechste.focus();
          else input.focus();
        });
        item.appendChild(weg);

        list.appendChild(item);
      });
    }

    function hinzufuegen(neue) {
      if (!neue || !neue.length) return;

      var abgewiesen = 0;
      var dubletten = 0;

      Array.prototype.slice.call(neue).forEach(function (f) {
        // Dubletten vermeiden, wenn dieselbe Datei zweimal gezogen wird
        var schon = gewaehlt.some(function (g) {
          return g.name === f.name && g.size === f.size;
        });
        if (schon) { dubletten++; return; }
        // Ueber der Grenze gar nicht erst aufnehmen — eine zu lange Liste mit
        // Fehlermeldung waere unfreundlicher als ein klarer Hinweis.
        if (gewaehlt.length >= MAX_DATEIEN) { abgewiesen++; return; }
        gewaehlt.push(f);
      });

      uebernehmen();
      pruefen();
      zeichnen();

      var text = gewaehlt.length + ' von ' + MAX_DATEIEN + ' Dateien ausgewählt.';
      if (abgewiesen > 0) {
        text += ' ' + abgewiesen + (abgewiesen === 1 ? ' weitere Datei wurde' : ' weitere Dateien wurden')
          + ' nicht übernommen, weil höchstens ' + MAX_DATEIEN + ' erlaubt sind.';
      } else if (dubletten > 0) {
        text += ' Bereits ausgewählte Dateien wurden übersprungen.';
      }
      ansagen(text);
      // Sichtbar machen, nicht nur fuer Screenreader
      if (hinweis) hinweis.textContent = (abgewiesen > 0 || dubletten > 0) ? text : '';
    }

    input.addEventListener('change', function () {
      hinzufuegen(input.files);
    });

    if (!drop) return;

    // Ziehen ist eine Zugabe; ohne diese Ereignisse bleibt der Klickweg intakt.
    var tiefe = 0;
    function an() { drop.classList.add('is-dragover'); }
    function aus() { drop.classList.remove('is-dragover'); }

    ['dragenter', 'dragover'].forEach(function (typ) {
      drop.addEventListener(typ, function (e) {
        e.preventDefault();
        if (typ === 'dragenter') tiefe++;
        an();
      });
    });

    drop.addEventListener('dragleave', function () {
      tiefe--;
      if (tiefe <= 0) { tiefe = 0; aus(); }
    });

    drop.addEventListener('drop', function (e) {
      e.preventDefault();
      tiefe = 0;
      aus();
      var dt = e.dataTransfer;
      if (dt && dt.files && dt.files.length) hinzufuegen(dt.files);
    });

    // Verhindern, dass ein Fehlwurf neben die Flaeche die Datei im Browser oeffnet
    ['dragover', 'drop'].forEach(function (typ) {
      window.addEventListener(typ, function (e) {
        if (!drop.contains(e.target)) e.preventDefault();
      });
    });
  }

  /* ---------------------------------------------------------------- */
  /* Absenden                                                          */
  /* ---------------------------------------------------------------- */

  function initSubmit(form, showError, clearErrors) {
    var status = qs(form, '[data-st-rv-status]');
    var button = qs(form, '[data-st-rv-submit]');
    var spinner = qs(form, '[data-st-rv-spinner]');

    function setStatus(message, kind) {
      if (!status) return;
      status.textContent = message;
      status.className = 'st-rv-status' + (kind ? ' is-' + kind : '');
    }

    function busy(on) {
      if (button) button.disabled = on;
      if (spinner) spinner.hidden = !on;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearErrors();
      setStatus('', '');

      var rated = qs(form, '[data-st-rv-rate-input]:checked');
      var files = Array.prototype.slice.call((qs(form, '[data-st-rv-files]') || {}).files || []);

      var input = {
        rating: rated ? parseInt(rated.value, 10) : null,
        title: (qs(form, '#st-rv-title') || {}).value || '',
        body: (qs(form, '#st-rv-body') || {}).value || '',
        authorName: (qs(form, '[data-st-rv-name]') || {}).value || '',
        consent: !!(qs(form, '[data-st-rv-consent]') || {}).checked
      };

      var check = core.validateSubmission(input);
      var fileCheck = core.validateFiles(files.map(function (f) {
        return { name: f.name, type: f.type, size: f.size };
      }));

      if (!check.valid || !fileCheck.valid) {
        Object.keys(check.errors).forEach(function (field) {
          showError(field, check.errors[field]);
        });
        if (!fileCheck.valid) showError('media', fileCheck.errors.join(' '));

        setStatus('Bitte prüfen Sie die markierten Felder.', 'error');
        var firstError = qs(form, '.st-rv-field-error:not(:empty)');
        if (firstError) firstError.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }

      var basis = (form.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
      if (!basis) {
        setStatus('Der Bewertungs-Server ist noch nicht eingerichtet. Bitte versuchen Sie es später erneut.', 'error');
        return;
      }

      var token = (qs(form, '[data-st-rv-token]') || {}).value || '';

      busy(true);
      setStatus(files.length
        ? 'Ihre Medien werden hochgeladen …'
        : 'Ihre Bewertung wird übermittelt …', '');

      function postJson(pfad, daten) {
        return fetch(basis + pfad, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(daten)
        }).then(function (response) {
          return response.json().catch(function () { return {}; })
            .then(function (data) { return { ok: response.ok, data: data }; });
        });
      }

      // Medien gehen NICHT ueber unseren Server, sondern direkt zu Shopify.
      // Das umgeht Upload-Limits des Hosters und spart Datenvolumen.
      function medienHochladen() {
        if (!files.length) return Promise.resolve([]);

        return postJson('/upload-targets', {
          token: token,
          files: files.map(function (f) { return { name: f.name, type: f.type, size: f.size }; })
        }).then(function (result) {
          if (!result.ok) throw new Error(result.data.message || 'Upload nicht möglich.');

          var targets = result.data.targets || [];
          return Promise.all(targets.map(function (target, i) {
            var daten = new FormData();
            (target.parameters || []).forEach(function (p) { daten.append(p.name, p.value); });
            daten.append('file', files[i]);

            return fetch(target.url, { method: 'POST', body: daten }).then(function (r) {
              if (!r.ok) throw new Error('Eine Datei konnte nicht hochgeladen werden.');
              return {
                originalSource: target.resourceUrl,
                contentType: files[i].type.indexOf('video/') === 0 ? 'VIDEO' : 'IMAGE'
              };
            });
          }));
        });
      }

      medienHochladen()
        .then(function (quellen) {
          if (files.length) setStatus('Ihre Bewertung wird übermittelt …', '');
          return postJson('/submit', {
            token: token,
            rating: input.rating,
            title: input.title,
            body: input.body,
            authorName: input.authorName,
            consent: input.consent,
            resourceUrls: quellen
          });
        })
        .then(function (result) {
          busy(false);
          if (!result.ok) {
            if (result.data.errors) {
              Object.keys(result.data.errors).forEach(function (feld) {
                showError(feld, result.data.errors[feld]);
              });
            }
            setStatus(result.data.message || 'Die Bewertung konnte nicht gespeichert werden. Bitte versuchen Sie es später erneut.', 'error');
            return;
          }
          form.reset();
          qsa(form, '.st-rv-rate__option').forEach(function (o) { o.classList.remove('is-on'); });
          var preview = qs(form, '[data-st-rv-preview]');
          if (preview) preview.innerHTML = '';
          var counter = qs(form, '[data-st-rv-counter]');
          if (counter) counter.textContent = '0';
          setStatus(result.data.message || 'Herzlichen Dank für Ihre Bewertung. Sie wird nach einer kurzen Prüfung veröffentlicht.', 'success');
        })
        .catch(function (e) {
          busy(false);
          setStatus((e && e.message) || 'Die Verbindung ist fehlgeschlagen. Bitte prüfen Sie Ihre Internetverbindung.', 'error');
        });
    });
  }

  /* ---------------------------------------------------------------- */
  /* Weitere Bewertungen einblenden                                    */
  /* ---------------------------------------------------------------- */

  function initShowMore(root) {
    var button = qs(root, '[data-st-rv-more]');
    if (!button) return;

    button.addEventListener('click', function () {
      qsa(root, '.st-rv__item.is-extra').forEach(function (item) {
        item.hidden = false;
        item.classList.remove('is-extra');
      });
      button.remove();
    });
  }

  /* ---------------------------------------------------------------- */
  /* Start                                                             */
  /* ---------------------------------------------------------------- */

  function initSection(root) {
    initShowMore(root);

    var form = qs(root, '[data-st-rv-form]');
    var gate = qs(root, '[data-st-rv-gate]');
    var token = getToken();

    if (!form) return;

    // Ohne gueltigen Einladungslink bleibt das Formular verborgen.
    if (!token) return;

    var tokenField = qs(form, '[data-st-rv-token]');
    if (tokenField) tokenField.value = token;

    /* Liegt noch keine Bewertung vor, liefert das Theme die Section verborgen
       aus — ein leerer Bewertungsblock wirkt wie ein Mangel. Wer aber ueber
       den Einladungslink kommt, soll bewerten koennen. Also hier sichtbar
       machen und hinscrollen. */
    if (root.hasAttribute('data-st-rv-nur-mit-einladung')) {
      root.hidden = false;
      root.removeAttribute('data-st-rv-nur-mit-einladung');
    }

    form.hidden = false;
    if (gate) gate.hidden = true;

    function showError(field, message) {
      var target = qs(form, '[data-st-rv-error="' + field + '"]');
      if (target) target.textContent = message || '';
    }
    function clearErrors() {
      qsa(form, '.st-rv-field-error').forEach(function (el) { el.textContent = ''; });
    }

    initRating(form);
    initCounter(form);
    initMask(form);
    initFiles(form, showError);
    initSubmit(form, showError, clearErrors);

    form.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  function boot() {
    qsa(document, '[data-st-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme-Editor: Section wird neu geladen
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-st-reviews]');
    if (root) initSection(root);
  });
})();
